import * as React from "react";
import type { SVGProps } from "react";
const SvgArkefly = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 50 50"
    width="100%"
    height="100%"
    {...props}
  >
    <g fill="#e41917">
      <path d="M2.375 16.143h11.886c1.165 0 2.043.368 2.389 2.023.384 1.84.226 3.12-1.845 3.267l-3.732.267c2.747 17.353 18.805 23.009 27.547 4.32 1.447-3.094 1.92-3.658 3.506-3.264 2.149.533 2.442 1.638 1.418 4.757-7.559 23.04-32.964 25.35-37.949-5.42l-3.032.22C.097 22.49 0 20.409 0 19.251c0-2.288.85-3.108 2.375-3.108M45.589 5a4.411 4.411 0 1 1 0 8.823 4.411 4.411 0 0 1 0-8.823" />
    </g>
  </svg>
);
export default SvgArkefly;
